import {useEffect, useState} from "react";
import Api from "../../services/Api.ts";
import { useAtom } from 'jotai';
import { categoriesAtom } from '../../jotai_state';

interface LicenseInterface {
  id: string
  credits: number
  created: string
  dateEnd: string
}

interface DataInterface {
  firstName: string
  licenses: LicenseInterface[]
  clientsPlatform: number
  clientsOnboarded: number
  clientsInvited: number
  clientLicenses: number
  feedbackUsers: number
  focusAreas: number
}

export default function Start() {
  const api = Api.getInstance();
  const [data, setData] = useState<DataInterface>({
    firstName: "",
    licenses: [],
    clientsPlatform: 0,
    clientsOnboarded: 0,
    clientsInvited: 0,
    clientLicenses: 0,
    feedbackUsers: 0,
    focusAreas: 0,
  });
  const [categories] = useAtom(categoriesAtom);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    getData();
  }, [categories]);

  const getData = () => {
    const data = {
      categories: categories,
    }

    api.post('customer/start', data).then((response) => {
      setData(response.json.data)
      setLoaded(true);
    })
  }

  const renderMain = () => {
    if (!loaded) {
      return <div>Loading data...</div>
    }
    return (
      <div>
        <div className="mt-4 text-3xl font-medium">Hi {data.firstName}</div>
        <p className="mt-2 text-neutral-800">
          This dashboard gives you an overview of your organization’s engagement and development.
        </p>
        <p className="text-neutral-800">
          Track user activity, monitor key metrics, and explore results across focus areas — all
          in one place.
        </p>

        <p className="mt-4 text-xl font-medium">Customer license</p>

        <div className="mt-2 z-box">
          {
            data.licenses.map(license => (
              <div key={"license_" + license.id}>
                <div className="flex justify-between">
                  <p className="text-neutral-800">Period:</p>
                  <p className="font-medium">
                    {license.created.substring(0, 10)} -&nbsp;
                    {license.dateEnd ? license.dateEnd.substring(0, 10) : 'No end'},&nbsp;
                    {license.credits} credits
                  </p>
                </div>
                <hr className="z-hr my-2"/>
              </div>
            ))
          }
          {
            data.licenses.length === 0 && (
              <p>No licenses (for video coaching)</p>
            )
          }
        </div>

        <p className="mt-4 text-xl font-medium">Nr of users</p>

        <div className="mt-2 z-box">
          <div className="flex justify-between">
            <p className="text-neutral-800">Platform access:</p>
            <p className="font-medium">
              {data.clientsPlatform}
            </p>
          </div>

          <hr className="z-hr my-2"/>

          <div className="flex justify-between">
            <p className="text-neutral-800">Coach plans:</p>
            <p className="font-medium">
              {data.clientLicenses}
            </p>
          </div>

          <hr className="z-hr my-2"/>

          <div className="flex justify-between">
            <p className="text-neutral-800">Feedback users:</p>
            <p className="font-medium">
              {data.feedbackUsers}
            </p>
          </div>

          <hr className="z-hr mt-2"/>
        </div>

        <p className="mt-4 text-xl font-medium">Onboarding</p>

        <div className="mt-2 z-box">
          <div className="flex justify-between">
            <p className="text-neutral-800">Users onboarded:</p>
            <p className="font-medium">
              {data.clientsOnboarded}
            </p>
          </div>

          <hr className="z-hr my-2"/>

          <div className="flex justify-between">
            <p className="text-neutral-800">Users invited, not onboarded:</p>
            <p className="font-medium">
              {data.clientsInvited}
            </p>
          </div>

          <hr className="z-hr mt-2"/>
        </div>

        <p className="mt-4 text-xl font-medium">Focus areas</p>

        <div className="mt-2 z-box">
          <div className="flex justify-between">
            <p className="text-neutral-800">Total focus areas:</p>
            <p className="font-medium">
              {data.focusAreas}
            </p>
          </div>
          <hr className="z-hr mt-2"/>
        </div>
      </div>
    )
  }

  return (
    <div className="main mx-8 my-4">
      {renderMain()}
    </div>
  );
}